import Image from "next/future/image";
import Link from "next/link";
import React from "react";
import { MdClose } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import { handleImageLink } from "@/helpers/functions";
import { useSelector } from "react-redux";

const MobileMenu = ({ showSidebar, setShowSidebar }) => {
  const { asPath, locale } = useRouter();
  const { settings } = useSelector((state) => state.settings);

  return (
    <div className={showSidebar ? "mobile-menu active" : "mobile-menu"}>
      <div className="menu-top d-flex align-items-center justify-content-between gap-3">
        <div className="logo">
          <Link href="/" prefetch={false}>
            <a>
              <Image
                src={
                  locale === "ar"
                    ? handleImageLink(settings?.appLogo)
                    : handleImageLink(settings?.appLogoEn)
                }
                width={140}
                height={50}
                alt="Logo"
                title={settings?.appName || ""}
              />
            </a>
          </Link>
        </div>
        <button
          type="button"
          onClick={() => setShowSidebar(false)}
          aria-label="Close Menu"
        >
          <MdClose color="#fff" size={30} />
        </button>
      </div>
      <div className="menu-bottom">
        <ul>
          <li>
            <Link href="/" prefetch={false}>
              <a className={asPath === "/" ? "active" : ""}>
                <FormattedMessage id="home" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/about" prefetch={false}>
              <a className={asPath === "/about" ? "active" : ""}>
                <FormattedMessage id="about-us" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/services" prefetch={false}>
              <a className={asPath.includes("services") ? "active" : ""}>
                <FormattedMessage id="services" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/projects" prefetch={false}>
              <a className={asPath.includes("projects") ? "active" : ""}>
                <FormattedMessage id="projects" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/blog" prefetch={false}>
              <a className={asPath.includes("blog") ? "active" : ""}>
                <FormattedMessage id="blog" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/faqs" prefetch={false}>
              <a className={asPath === "/faqs" ? "active" : ""}>
                <FormattedMessage id="faqs" />
              </a>
            </Link>
          </li>
          <li>
            <Link href="/contact" prefetch={false}>
              <a className={asPath === "/contact" ? "active" : ""}>
                <FormattedMessage id="request" />
              </a>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
